import React from 'react';
import styles from './navbar.module.css'



const Navbar = () => {
  return (
    <div>
        
        <div className={styles.nav}>
        <p className={styles.name}>Ratnesh </p>
        <a href='#profile_section'>About</a>
        <a href='#skill_section'>Skills</a>
        <a href='#project_section'>Projects</a>
        <a href='#contact_section'>Contact</a>
    </div>
        </div>
  
  )
}

export default Navbar